// extracted by mini-css-extract-plugin
export default {"submitButton":"style_submitButton__5ooyR","center":"style_center__3B2K-"};